import { render, staticRenderFns } from "./appearance.vue?vue&type=template&id=5f7f99b6&scoped=true&"
import script from "./appearance.vue?vue&type=script&lang=js&"
export * from "./appearance.vue?vue&type=script&lang=js&"
import style0 from "./appearance.vue?vue&type=style&index=0&id=5f7f99b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7f99b6",
  null
  
)

export default component.exports